import * as React from 'react';
import { useTenantEntity } from '@/components/access/tenant-entity-provider';
import { useSession } from '@/components/auth/user-provider';

export function useSowBoundary() {
  const access = useTenantEntity(), { session } = useSession();
  const identity = session.status === 'signedIn' ? session.user.email || session.user.name : session.status;
  return { access, identity, key: [identity, access.selected?.tenantId, access.selected?.entityId].join(':') };
}
/** Mutation callbacks are fenced even when a provider ignores AbortSignal. */
export function useSowRequest() {
  const controller = React.useRef(new AbortController());
  const generation = React.useRef(0), alive = React.useRef(true);
  React.useEffect(() => {
    alive.current = true;
    if (controller.current.signal.aborted) controller.current = new AbortController();
    return () => { alive.current = false; generation.current++; controller.current.abort(); };
  }, []);
  return { request: { get signal() { return controller.current.signal; } },
    token: () => generation.current, active: (token: number) => alive.current && token === generation.current };
}
